import Phaser from 'phaser'

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' })
  }

  preload(): void {
    // Load minimal assets needed for the preloader UI
    // For now, we'll create a simple loading bar programmatically
  }

  create(): void {
    // Initialize any global game settings
    this.scale.on('resize', this.handleResize, this)

    // Transition to preload scene
    this.scene.start('PreloadScene')
  }

  private handleResize(gameSize: Phaser.Structs.Size): void {
    const width = gameSize.width
    const height = gameSize.height

    this.cameras.resize(width, height)
  }
}
